module.exports = __webpack_public_path__ + "assets/fanqiejiang.5316b785.svg";